export default __webpack_public_path__ + "static/media/BetButtonGlow.9dca2456.png";